/* eslint-disable react-hooks/rules-of-hooks */

import { useEffect } from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
// eslint-disable-next-line import/extensions
import { BrowserRouter } from 'react-router-dom';

import { PersistGate } from 'redux-persist/integration/react';
import { Provider, useDispatch } from 'react-redux';
import ReactGA from 'react-ga4';
import moment from 'moment';

import { GoogleOAuthProvider } from '@react-oauth/google';
import keycloak from './keycloak';
import store, { persistor } from './app/index';
import App from './App';
import './locales';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.scss';
import { onSignInSuccess } from './app/auth/authSlice';

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const trackingId = import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_KEY;

moment.locale('en');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// const eventLogger = (__event: unknown, __error: unknown) => {
//   console.log('onKeycloakEvent', event, error);
// };

// eslint-disable-next-line react-refresh/only-export-components
function KeycloakWrapper() {
  const dispatch = useDispatch();
  const tokenLogger = (tokens: any) => {
    dispatch(onSignInSuccess(tokens?.token));
  };

  useEffect(() => {
    // Remove preloader when React is ready
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }, []);

  const eventLogger = async (event: string, _error: any) => {
    if (event === 'onTokenExpired') {
      console.warn('[Keycloak] Token expired — trying to refresh...');
      try {
        const refreshed = await keycloak.updateToken(5); // refresh if token will expire in 5s
        if (refreshed) {
          console.log('[Keycloak] Token successfully refreshed on expiration');
          dispatch(onSignInSuccess(keycloak.token));
        } else {
          console.log('[Keycloak] Token was still valid');
        }
      } catch (err) {
        console.error('[Keycloak] Failed to refresh token on expiration', err);
        // if needed redirect to login page
      }
    }
  };

  if (trackingId) {
    ReactGA.initialize(trackingId);
    ReactGA.send({ hitType: 'pageView', path: window.location.pathname });
  }

  return (
    <ReactKeycloakProvider
      initOptions={{ onLoad: 'login-required', checkLoginIframe: false }}
      authClient={keycloak}
      onEvent={eventLogger}
      onTokens={tokenLogger}
    >
      <GoogleOAuthProvider clientId={googleClientId}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </GoogleOAuthProvider>
    </ReactKeycloakProvider>
  );
}

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <KeycloakWrapper />
    </PersistGate>
  </Provider>
);
